import api from './apiService';

/**
 * Busca a lista de metas orçamentárias ativas com o progresso do mês especificado.
 * @param {number} ano
 * @param {number} mes
 * @param {'competencia'|'fatura'} [regime='competencia']
 */
export const getMetasComProgresso = async (ano, mes, regime = 'competencia') => {
    const response = await api.get('/financeiro/metas/progresso/', {
        params: { ano, mes, regime },
    });
    return response.data;
};

/**
 * Lista lançamentos (e projeções) que compõem o progresso de uma categoria no mês.
 * @param {number} ano
 * @param {number} mes
 * @param {number} categoriaId
 * @param {'competencia'|'fatura'} [regime='competencia']
 */
export const getDetalheMetaProgresso = async (ano, mes, categoriaId, regime = 'competencia') => {
    const response = await api.get('/financeiro/metas/progresso/detalhe/', {
        params: { ano, mes, categoria_id: categoriaId, regime },
    });
    return response.data;
};

/**
 * Cria ou atualiza uma meta orçamentária.
 * @param {number|null} metaId - O ID da meta a ser atualizada, ou null para criar uma nova.
 * @param {object} payload - Os dados da meta, ex: { categoria_id, valor }.
 */
export const createOrUpdateMeta = async (metaId, payload) => {
    if (metaId) {
        const response = await api.put(`/financeiro/metas/${metaId}/`, payload);
        return response.data;
    } else {
        const response = await api.post('/financeiro/metas/', payload);
        return response.data;
    }
};

/**
 * Desativa (soft delete) uma meta orçamentária.
 * @param {number} metaId - O ID da meta a ser desativada.
 */
export const deleteMeta = async (metaId) => {
    await api.delete(`/financeiro/metas/${metaId}/`);
};

/** Lista metas de poupança ativas com progresso (saldo da conta / valor alvo). */
export const getMetasPoupancaComProgresso = async () => {
    const response = await api.get('/financeiro/metas-poupanca/progresso/');
    return response.data;
};

/**
 * Cria ou atualiza meta de poupança.
 * @param {number|null} metaId
 * @param {object} payload - { nome, tipo, conta_id, valor_alvo, data_limite?, meses_cobertura? }
 */
export const createOrUpdateMetaPoupanca = async (metaId, payload) => {
    if (metaId) {
        const response = await api.put(`/financeiro/metas-poupanca/${metaId}/`, payload);
        return response.data;
    }
    const response = await api.post('/financeiro/metas-poupanca/', payload);
    return response.data;
};

export const deleteMetaPoupanca = async (metaId) => {
    await api.delete(`/financeiro/metas-poupanca/${metaId}/`);
};

/**
 * Aporte manual (transferência) para a conta da meta.
 * @param {number} metaId
 * @param {{ conta_origem_id: number, valor: number, data?: string, descricao?: string }} payload
 */
export const registrarAporteMetaPoupanca = async (metaId, payload) => {
    const response = await api.post(`/financeiro/metas-poupanca/${metaId}/aporte/`, payload);
    return response.data;
};

/**
 * Resgate manual da caixinha para outra conta.
 * @param {number} metaId
 * @param {{ conta_destino_id: number, valor: number, data?: string, descricao?: string }} payload
 */
export const registrarResgateMetaPoupanca = async (metaId, payload) => {
    const response = await api.post(`/financeiro/metas-poupanca/${metaId}/resgate/`, payload);
    return response.data;
};

/**
 * Sugestão de valor para reserva de emergência.
 * @param {number} [mesesCobertura=6]
 */
export const getSugestaoReserva = async (mesesCobertura = 6) => {
    const response = await api.get('/financeiro/metas-poupanca/sugestao-reserva/', {
        params: { meses_cobertura: mesesCobertura },
    });
    return response.data;
};

/**
 * Cria ou atualiza meta de faturamento mensal (1 ativa por usuário).
 * @param {number|null} metaId
 * @param {{ valor_alvo: number }} payload
 */
export const createOrUpdateMetaFaturamento = async (metaId, payload) => {
    if (metaId) {
        const response = await api.put(`/financeiro/metas-faturamento/${metaId}/`, payload);
        return response.data;
    }
    const response = await api.post('/financeiro/metas-faturamento/', payload);
    return response.data;
};

export const deleteMetaFaturamento = async (metaId) => {
    await api.delete(`/financeiro/metas-faturamento/${metaId}/`);
};
